export default __webpack_public_path__ + "static/media/Group9418.03907060.svg";